<p-table
  #dt
  class="table-parameters table-simple-paginator m-4"
  [alwaysShowPaginator]="false"
  [value]="providers"
  [columns]="cols"
  [paginator]="true"
  [rows]="amountOfRows"
  [totalRecords]="totalRecords"
  [lazy]="true"
  [filterDelay]="1000"
  (onLazyLoad)="loadData($event)"
  [loading]="isLoading"
>
  <!-- <ng-template pTemplate="colgroup" let-columns>
  <colgroup>
  <col *ngFor="let col of columns" [style.width]="col.width" />
</colgroup>
</ng-template> -->
  <ng-template pTemplate="header" let-columns>
    <!-- <tr class="header-sorting"> -->
    <tr>
      @for (col of columns; track col) {
        <th
          [pSortableColumn]="unsortedFields.includes(col.field) ? '' : col.field"
          [pSortableColumnDisabled]="unsortedFields.includes(col.field)"
        >
          <div class="flex items-center gap-2">
            {{ col.header }}
            @if (!unsortedFields.includes(col.field) && col.header !== '') {
              <p-sortIcon
                [field]="col.field"
                aria-label="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              />
            }
          </div>
        </th>
      }
    </tr>
    <!-- <tr class="header-filter"> -->
    <tr class="header-filter">
      <th>
        <p-multiSelect
          #providerNameDropdown
          [options]="providerNameList"
          (onChange)="filterTable($event.value, 'providerName', 'in'); providerNameDropdown.hide()"
          [(ngModel)]="providerName"
          placeholder="Filter"
          [disabled]="disableFilters()"
        ></p-multiSelect>
      </th>
      <th>
        <p-select
          placeholder="Filter"
          [options]="activeStateList"
          [showClear]="true"
          (onChange)="filterTable($event.value, 'isActive', 'eq')"
          [(ngModel)]="userActiveFilter"
          [disabled]="disableFilters()"
        />
      </th>
      <th>
        <p-multiSelect
          #providerAddressDropdown
          [options]="providerAddressList"
          (onChange)="filterTable($event.value, 'providerAddress', 'in'); providerAddressDropdown.hide()"
          [(ngModel)]="providerAddress"
          placeholder="Filter"
          [disabled]="disableFilters()"
        />
      </th>
      <th>
        <p-multiSelect
          #npiDropdown
          [options]="npiList"
          (onChange)="filterTable($event.value, 'npi', 'in'); npiDropdown.hide()"
          [(ngModel)]="npi"
          placeholder="Filter"
          [disabled]="disableFilters()"
        />
      </th>
      <th>
        <p-multiSelect
          #taxIdDropdown
          [options]="taxIdList"
          (onChange)="filterTable($event.value, 'taxId', 'in'); taxIdDropdown.hide()"
          [(ngModel)]="taxId"
          placeholder="Filter"
          [disabled]="disableFilters()"
        />
      </th>
      <th>
        <p-multiSelect
          #healthPlanDropdown
          [options]="healthPlanList"
          (onChange)="filterTable($event.value, 'tenantName', 'in'); healthPlanDropdown.hide()"
          [(ngModel)]="tenantName"
          placeholder="Filter"
          [showHeader]="false"
          [disabled]="disableFilters()"
        />
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        <p>{{ isLoading ? 'Loading... please wait' : 'No record found' }}</p>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-provider>
    <tr>
      <td>{{ provider.providerName }}</td>
      <td>{{ provider.isActive ? 'Active' : 'Inactive' }}</td>
      <td>{{ provider.providerAddress }}</td>
      <td>{{ provider.npi }}</td>
      <td>{{ provider.taxId }}</td>
      <td>{{ provider.tenantName }}</td>
    </tr>
  </ng-template>
</p-table>
